module.exports = __webpack_public_path__ + "media/images/icons/newsletter-364ab5ce54b735542ebdba6d7bfef7d8.svg";